type ProductSelectionLike = {
  choose?: boolean | null;
  companyCode?: string | null;
} | null | undefined;

export function shouldOnlyProvideOneProductForLegacy(
  products?: ProductSelectionLike[],
): boolean {
  const productsWithCompany = (products || []).filter(
    (product): product is { companyCode: string; choose?: boolean | null } =>
      !!product?.companyCode,
  );

  return (
    productsWithCompany.length > 0 &&
    new Set(productsWithCompany.map((product) => product.companyCode)).size === 1
  );
}

export function shouldOnlyProvideOneProductForZuu(
  products?: ProductSelectionLike[],
): boolean {
  return shouldOnlyProvideOneProductForLegacy(products);
}
